export default <NotificationsStore>{
  detail: {
    id: '',
    teamId: 0,
    firstNotificationId: 0,
    disasterType: 0,
    prefecture: 0,
    intensity: 0,
    sentDatetime: '',
    isManual: false,
    message: '',
    sentExecutionCount: 0,
    sentSuccessCount: 0,
    sentServerErrorCount: 0,
    replyCount: 0,
    resentTimes: 0,
    createdAt: '',
    noReplyCount: 0,
    personsInjured: 0,
    notificationIds: [],
    recentSearchDatetime: '',
    sender: '',
    pagination: {
      data: {
        active: [],
        afterDistant: [],
        afterNear: [],
        beforeDistant: [],
        beforeNear: [],
        first: [],
        last: [],
      },
      sort: '-replyDatetime',
      current: 1,
      totalCount: 0,
      totalPages: 0,
      disabled: false,
    },
    search: {
      names: [],
      positions: [],
      organizations: [],
      isAnswered: false,
      isSafe: false,
      isMinorInjury: false,
      isSeriousInjury: false,
      sort: '-replyDatetime',
    },
    answer: {
      id: 0,
      lastName: '',
      firstName: '',
      isAnswered: false,
      injuryStatus: 0,
      message: '',
      replyDatetime: '',
      sentDatetime: '',
    },
  },
  pagination: {
    data: {
      active: [],
      afterDistant: [],
      afterNear: [],
      beforeDistant: [],
      beforeNear: [],
      first: [],
      last: [],
    },
    sort: '-sentDatetime',
    current: 1,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  },
  search: {
    fromSentDatetime: '',
    toSentDatetime: '',
    disasterType: null,
    prefecture: null,
  },
};
